export default {
	
	validations: {
		required: "Une valeur est requise.",
		email: "La valeur n'est pas une adresse e-mail valide",
		minLength: "Ce champ doit contenir au moins ${min} caractères",
		maxLength: "La longueur maximale autorisée est de ${max}",
		minValue: "La valeur minimale autorisée est ${min}",
		maxValue: "La valeur maximale autorisée est ${max}",
		numeric: "La valeur doit être numérique",
		ipAddress: "La valeur n'est pas une adresse IP valide",
		sameAs: "La valeur doit être égale à la valeur ${otherName}",
	}
}